
const IssueResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	"success": true,
	"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
	"ticketBusRef": "string",
	"token": "string",
	"busId": "string",
	"totalPrice": 0,
	"issueCode": "string"
};
 

  export default IssueResponse;
  